import { useContext, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { AppContext } from '../../common';
import TabHeader from '../../common/components/tab-seccion/TabHeader';
import TabSeccion from '../../common/components/tab-seccion/TabSeccion';
import { PendingRequestsByAuthorizer } from '../../models/requests-management/pendingRequest';
import { RequestsManagementsAPI } from '../../services/external/APIs/requests-managements/RequestsManagements';
import { useGetCoversAuthorizer } from '../employees-portal/hooks/useGetCoversAuthorizer';
import { DetailsRequest } from './DetailsRequest';
import { LoadingTable } from './components/table';
import { CoverManagementModal } from '../employees-portal/components/modals/CoverManagementModal';
import { getActionService } from '../../utils/getActionService';
import { ACTIONS } from '../../constants';
import { CoverTab } from './components/tabs/CoverTab';

export const RequestManagement = () => {
    const { langResources, userInfo } = useContext(AppContext);

    const {
        coversList,
        coversListCopy,
        errorMessage,
        handlerReloading,
        isLoadingCovers,
        setCoversListCopy,
    } = useGetCoversAuthorizer();

    let { params } = useParams();
    const searchParams = new URLSearchParams(document.location.search);
    const [activeNav, setActiveNav] = useState<number>(1);

    const [isOpenModalCoverManagement, setIsOpenModalCoverManagement] =
        useState(false);
    const [statusCoverManagement, setStatusCoverManagement] = useState('');

    const [coverManagementId, setCoverManagementId] = useState<string>(
        searchParams.get('SchedulingCoverRequestId') ?? ''
    );

    const [pendingsRequests, setPendingsRequests] =
        useState<PendingRequestsByAuthorizer>();
    const [pendingsRequestsCopy, setPendingsRequestsCopy] =
        useState<PendingRequestsByAuthorizer>();
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [selectedWorkshiftId, setSelectedWorkshiftId] = useState<string>(
        searchParams.get('SchedulingChangeRequestId') ?? ''
    );
    const [selectedInterruptionId, setSelectedInterruptionId] = useState<string>(
        searchParams.get('InterruptionRequestId') ?? ''
    );

    const handleFetchPendingRquests = () => {
        setIsLoading(true);
        RequestsManagementsAPI.getRequestsPendingRequestsByAuthorizer().then(
            (res) => {
                setPendingsRequests(res);
                setPendingsRequestsCopy(res);
                setIsLoading(false);
            }
        );
    };

    useEffect(() => {
        handleFetchPendingRquests();
    }, [selectedInterruptionId]);

    const handlerSearch = (searchTerm: string, flag: string) => {
        if (searchTerm.length == 0) setPendingsRequests(pendingsRequestsCopy);
        else if (flag === 'workshift' && pendingsRequests) {
            let newList =
                pendingsRequests.workshiftSchedulingChangeRequests.filter(
                    (i) =>
                        i.documentNumber.includes(searchTerm) ||
                        i.fullName.toLowerCase().includes(searchTerm) ||
                        i.workshiftName.toLowerCase().includes(searchTerm)
                ) ?? [];

            let copy: PendingRequestsByAuthorizer = { ...pendingsRequests };
            copy.workshiftSchedulingChangeRequests = newList;

            setPendingsRequests(copy);
        } else if (flag === 'interruption' && pendingsRequests) {
            let newList = pendingsRequests.interruptionRequests.filter(
                (i) =>
                    i.documentNumber.includes(searchTerm) ||
                    i.fullName.toLowerCase().includes(searchTerm) ||
                    i.interruptionTypeName.toLowerCase().includes(searchTerm)
            );

            let copy: PendingRequestsByAuthorizer = { ...pendingsRequests };
            copy.interruptionRequests = newList;

            setPendingsRequests(copy);
        }
    };

    const handlerSearchCovers = (searchTerm: string) => {
        if (searchTerm.length == 0) setCoversListCopy(coversList);

        if (coversListCopy.length > 0) {
            let newList = coversListCopy.filter(
                (i) =>
                    i.fullName.includes(searchTerm) ||
                    i.fullNameCoverPerson.toLowerCase().includes(searchTerm)
            );

            setCoversListCopy(newList);
        }
    };

    const handlerManagementModal = (status: string, id: number) => {
        setIsOpenModalCoverManagement(true);
        setStatusCoverManagement(status);
        setCoverManagementId(id.toString());
    };

    useEffect(() => {
        if (searchParams.get('SchedulingCoverRequestId')) {
            setActiveNav(3);
            setIsOpenModalCoverManagement(true);

            if (params == 'approved') {
                setStatusCoverManagement('aprobar');
            } else if (params == 'rejected') {
                setStatusCoverManagement('rechazar');
            }
        }
    }, []);

    return (
        <>
            <CoverManagementModal
                isOpenModal={isOpenModalCoverManagement}
                onClose={() => setIsOpenModalCoverManagement(false)}
                status={statusCoverManagement}
                handlerReloading={handlerReloading}
                id={Number(coverManagementId)}
            />

            <div className='mt-5'>
                <div className='m-3 pt-3'>
                    <div className='card p-3'>
                        <h3 className=' mt-3'>Aprobar solicitudes pendientes</h3>
                        <div className='card-header'>
                            <ul
                                role='tablist'
                                id={'profile-tabs'}
                                className='nav-tabs-custom rounded card-header-tabs border-bottom-0 nav'
                            >
                                {getActionService(
                                    userInfo.actions,
                                    ACTIONS['approved.scheduling']
                                ) && (
                                    <TabHeader
                                        currentActiveNav={activeNav}
                                        activeNavValue={1}
                                        setActiveNav={setActiveNav}
                                        text={'Solicitudes de Turnos'}
                                    />
                                )}

                                {getActionService(
                                    userInfo.actions,
                                    ACTIONS['approve.interruptions']
                                ) && (
                                    <TabHeader
                                        currentActiveNav={activeNav}
                                        activeNavValue={2}
                                        setActiveNav={setActiveNav}
                                        text={'Solicitudes de Interrupciones'}
                                    />
                                )}

                                {getActionService(
                                    userInfo.actions,
                                    ACTIONS['approve.covers']
                                ) && (
                                    <TabHeader
                                        currentActiveNav={activeNav}
                                        activeNavValue={3}
                                        setActiveNav={setActiveNav}
                                        text={'Solicitudes de Cubrimientos'}
                                    />
                                )}
                            </ul>
                        </div>

                        <div className='card-body p-3'>
                            <div className='tab-content'>
                                {getActionService(
                                    userInfo.actions,
                                    ACTIONS['approved.scheduling']
                                ) && (
                                    <TabSeccion
                                        activeNavValue={1}
                                        currentActiveNav={activeNav}
                                    >
                                        <div>
                                            {selectedWorkshiftId !== '' ? (
                                                <DetailsRequest
                                                    handleFetchPendingRquests={
                                                        handleFetchPendingRquests
                                                    }
                                                    id={selectedWorkshiftId}
                                                    type='workshift'
                                                    status={params}
                                                    changeSelectedId={
                                                        setSelectedWorkshiftId
                                                    }
                                                />
                                            ) : isLoading ? (
                                                <LoadingTable />
                                            ) : (
                                                <>
                                                    <div>
                                                        <input
                                                            type='text'
                                                            className='form-control w-25'
                                                            placeholder='Buscar...'
                                                            onChange={(e) =>
                                                                handlerSearch(
                                                                    e.target.value,
                                                                    'workshift'
                                                                )
                                                            }
                                                        />
                                                    </div>
                                                    <table className=' table text-center align-items-center text-black'>
                                                        <thead>
                                                            <tr>
                                                                <th scope='col'>
                                                                    Nombre
                                                                </th>
                                                                <th scope='col'>
                                                                    Documento
                                                                </th>
                                                                <th scope='col'>
                                                                    Nuevo Turno
                                                                </th>
                                                                <th scope='col'>
                                                                    Fecha Inicial
                                                                </th>
                                                                <th scope='col'>
                                                                    Fecha Final
                                                                </th>
                                                                <th scope='col'>
                                                                    Ver
                                                                </th>
                                                            </tr>
                                                        </thead>

                                                        <tbody>
                                                            {pendingsRequests?.workshiftSchedulingChangeRequests &&
                                                            pendingsRequests
                                                                .workshiftSchedulingChangeRequests
                                                                .length > 0 ? (
                                                                pendingsRequests.workshiftSchedulingChangeRequests.map(
                                                                    (request) => (
                                                                        <tr
                                                                            key={
                                                                                request.workshiftSchedulingChangeRequestId
                                                                            }
                                                                        >
                                                                            <td>
                                                                                {
                                                                                    request.fullName
                                                                                }
                                                                            </td>
                                                                            <td>
                                                                                {
                                                                                    request.documentNumber
                                                                                }
                                                                            </td>
                                                                            <td>
                                                                                {
                                                                                    request.workshiftName
                                                                                }
                                                                            </td>
                                                                            <td>
                                                                                {new Date(
                                                                                    request.startDate
                                                                                ).toLocaleDateString()}
                                                                            </td>
                                                                            <td>
                                                                                {new Date(
                                                                                    request.endDate
                                                                                ).toLocaleDateString()}
                                                                            </td>
                                                                            <td>
                                                                                <button
                                                                                    className='btn btn-light btn-sm rounded-pill'
                                                                                    onClick={(
                                                                                        e
                                                                                    ) => {
                                                                                        e.stopPropagation();
                                                                                        setSelectedWorkshiftId(
                                                                                            request.workshiftSchedulingChangeRequestId.toString()
                                                                                        );
                                                                                    }}
                                                                                >
                                                                                    <i className='ri-eye-fill'></i>
                                                                                </button>
                                                                            </td>
                                                                        </tr>
                                                                    )
                                                                )
                                                            ) : (
                                                                <th colSpan={6}>
                                                                    <p>
                                                                        No hay
                                                                        registros ...
                                                                    </p>
                                                                </th>
                                                            )}
                                                        </tbody>
                                                    </table>
                                                </>
                                            )}
                                        </div>
                                    </TabSeccion>
                                )}

                                {getActionService(
                                    userInfo.actions,
                                    ACTIONS['approve.interruptions']
                                ) && (
                                    <TabSeccion
                                        activeNavValue={2}
                                        currentActiveNav={activeNav}
                                    >
                                        <div>
                                            {selectedInterruptionId !== '' ? (
                                                <DetailsRequest
                                                    handleFetchPendingRquests={
                                                        handleFetchPendingRquests
                                                    }
                                                    id={selectedInterruptionId}
                                                    type='interruption'
                                                    status={params}
                                                    changeSelectedId={
                                                        setSelectedInterruptionId
                                                    }
                                                />
                                            ) : isLoading ? (
                                                <LoadingTable />
                                            ) : (
                                                <>
                                                    <div>
                                                        <input
                                                            type='text'
                                                            className='form-control w-25'
                                                            placeholder='Buscar...'
                                                            onChange={(e) =>
                                                                handlerSearch(
                                                                    e.target.value,
                                                                    'workshift'
                                                                )
                                                            }
                                                        />
                                                    </div>

                                                    <table className='table text-center align-items-center text-black'>
                                                        <thead>
                                                            <tr>
                                                                <th scope='col'>
                                                                    Nombre
                                                                </th>
                                                                <th scope='col'>
                                                                    Documento
                                                                </th>
                                                                <th scope='col'>
                                                                    Interrupción
                                                                </th>
                                                                <th scope='col'>
                                                                    Fecha
                                                                </th>
                                                                <th scope='col'>
                                                                    Ver
                                                                </th>
                                                            </tr>
                                                        </thead>

                                                        <tbody>
                                                            {pendingsRequests?.interruptionRequests &&
                                                            pendingsRequests
                                                                .interruptionRequests
                                                                .length > 0 ? (
                                                                pendingsRequests.interruptionRequests.map(
                                                                    (request) => (
                                                                        <tr
                                                                            key={
                                                                                request.interruptionRequestId
                                                                            }
                                                                        >
                                                                            <td>
                                                                                {
                                                                                    request.fullName
                                                                                }
                                                                            </td>
                                                                            <td>
                                                                                {
                                                                                    request.documentNumber
                                                                                }
                                                                            </td>
                                                                            <td>
                                                                                {
                                                                                    request.interruptionTypeName
                                                                                }
                                                                            </td>
                                                                            <td>
                                                                                {new Date(
                                                                                    request.endDate
                                                                                ).toLocaleDateString()}
                                                                            </td>
                                                                            <td>
                                                                                <button
                                                                                    className='btn btn-light btn-sm rounded-pill'
                                                                                    onClick={(
                                                                                        e
                                                                                    ) => {
                                                                                        e.stopPropagation();
                                                                                        setSelectedInterruptionId(
                                                                                            request.interruptionRequestId.toString()
                                                                                        );
                                                                                    }}
                                                                                >
                                                                                    <i className='ri-eye-fill'></i>
                                                                                </button>
                                                                            </td>
                                                                        </tr>
                                                                    )
                                                                )
                                                            ) : (
                                                                <th colSpan={6}>
                                                                    <p>
                                                                        No hay
                                                                        registros ...
                                                                    </p>
                                                                </th>
                                                            )}
                                                        </tbody>
                                                    </table>
                                                </>
                                            )}
                                        </div>
                                    </TabSeccion>
                                )}

                                {getActionService(
                                    userInfo.actions,
                                    ACTIONS['approve.covers']
                                ) && (
                                    <TabSeccion
                                        activeNavValue={3}
                                        currentActiveNav={activeNav}
                                    >
                                        {isLoadingCovers ? (
                                            <LoadingTable />
                                        ) : (
                                            <CoverTab
                                                coversListCopy={coversListCopy}
                                                handlerManagementModal={
                                                    handlerManagementModal
                                                }
                                                handlerSearchCovers={
                                                    handlerSearchCovers
                                                }
                                            />
                                        )}
                                    </TabSeccion>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};
